import sponsorsData from "../../data/sponsors.json";
import styles from "./SponsorSection.module.css";
import { tracking } from '../../../../utils/tracking';

const Image = ({ url }) => {
   return <img src={url} alt="" />;
};

export const SponsorSection = () => {

   return (
      <div className={styles.sponsors}>
         {sponsorsData.length > 0 && <h1 >OUR PARTNERS</h1>}
         {sponsorsData.map((sponsor_type, i) => {
            const { name, values } = sponsor_type;
            return (
               <div className={styles.sponsor} key={i}>
                  <h3>{name.toUpperCase().replace(/_/g, " ")}</h3>
                  <div className={styles.logos}>
                     {values.map(sponsor => (
                        <div key={sponsor.logo_url} className={styles.logo}
                           onClick={() => tracking(282, sponsor.id)}
                        >
                           <a href={sponsor.website} rel='noreferrer' target='_blank'>
                              <Image url={sponsor.logo_url} />
                           </a>
                        </div>
                     ))
                     }
                  </div>
               </div>
            )
         })}
      </div>
   );
};
